import { render, staticRenderFns } from "./setWorkbenches.vue?vue&type=template&id=04ef587a&scoped=true&"
import script from "./setWorkbenches.vue?vue&type=script&lang=js&"
export * from "./setWorkbenches.vue?vue&type=script&lang=js&"
import style0 from "./setWorkbenches.vue?vue&type=style&index=0&id=04ef587a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04ef587a",
  null
  
)

export default component.exports